<template>
    <div>
        <Loader :is-visible="isLoading"></Loader>
        <div class="container-login">
            <div class="login">
                <img class="logo-img" src="./../assets/images/logo/logo.d5273f0.png" alt="">
                <div class="login__heading mg-top1">
                    <!-- <h1>Welcome Back</h1> -->
                    <p>Enter your credentials to access your account</p>
                </div>
                <form @submit.prevent="login">
                    <div class="wrapper mg-top1">
                        <div class="login__input">
                            <img src="./../assets/images/icon/iconmonstr-smartphone-4.svg" alt="https://iconmonstr.com/">
                            <!-- <input type="number" v-model="number"> -->
                            <div class="input-data">
                                <input type="number" required v-model="number">
                                <div class="underline"></div>
                                <label>Enter your phone number</label>
                            </div>
                        </div>
                        <div class="login__input">
                            <img src="./../assets/images/icon/iconmonstr-lock-3 (1).svg" alt="https://iconmonstr.com/">
                            <!-- <input type="password" v-model="password"> -->
                            <div class="input-data mg-top">
                                <!-- <input :type="type" required v-model="password"> -->
                                <input   v-bind:type="[showPassword ? 'text' : 'password']" required v-model="password">
                                <span class="showpass" @click="showPassword = !showPassword">
                                    <i class="fas" :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="true"></i>
                                </span>
                                <div class="underline"></div>
                                <label>Enter your password</label>
                            </div>
                        </div>
                    </div>
                    <vue-recaptcha
                        ref="recaptcha"
                        sitekey="6LchbckbAAAAAAjauRfyDJqIWfkAlFdsIDu_dnH5"
                        :loadRecaptchaScript="true"
                        size="invisible"
                        @verify="onVerify"
                    />
                    <button class="btn-login mg-top">
                        Login
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';
import Loader from '../components/Loader.vue';
import alert from '../commons/alert.helper';

import auth from '@/service/auth.js'

export default {
    name: 'Login',
    components: {
        VueRecaptcha,
        Loader
    },
    data() {
        return {
            isLoading: false,
            number: '',
            password: '',
            type: 'password',
            showPassword: false,
            // btnText: ''
        }
    },
    methods: {
        async login () {
            this.$refs.recaptcha.execute()
        },
        onVerify (response) {
            if (response) {
                this.isLoading = true
                const params = new URLSearchParams()
                // params.append('number', parseInt(this.number, 10))
                params.append('number', this.number)
                // let num = 089637923393
                // params.append('number', num)
                params.append('password', this.password)
                // params.append('password', 'test')
                // 089637923393 test
                const config = {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
                axios.post(`/auth/login`, params, config)
                    .then((result) => {

                        console.log('auth', result)

                        localStorage.setItem('token', result.data.token)
                        localStorage.setItem('number', result.data.phone_number)
                        localStorage.setItem('expired', result.data.expired_datetime)

                        this.checkRole()
                        // this.isLoading = false
                    })
                    .catch((err) => {
                        console.log(err)
                        this.isLoading = false
                        alert.failed('Unregistered number or wrong password', () => this.$router.go())
                        // alert.failed('Unregistered number or wrong password', () =>  this.$router.push('/'))
                    })
            }
        },
        async checkRole () {
            this.isLoading = true
            let res = await auth.checkToken()
            if (res) {
                try {
                    const response = await axios.get(`/member/authorization?user_id=${res}`)
                    console.log('test', response)
                    if (response.status == 200 && response.data.is_admin == true) {
                        this.$router.push('/')
                        this.$router.go()
                    } else if (response.status == 200 && response.data.is_admin == false) {
                        localStorage.clear()
                        alert.failed('You Are not an Administrator', () =>  this.$router.push('/login'))
                        this.$router.go()
                    } 
                    this.isLoading = false
                    
                } catch (err) {
                    console.log(err)
                    this.isLoading = false
                    localStorage.clear()
                    alert.failed('Complete ur personal information first' , () =>  this.$router.push('/login'))
                }
            }
        }
    }
}
</script>